import React, { useEffect, useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import PulseLoader from "react-spinners/PulseLoader";

import api from "services/api";

import { Card } from "@mui/material";
import Grid from "@mui/material/Grid";

import { Empty } from "antd";

import Tooltip from "@mui/material/Tooltip";
import Pagination from "@mui/material/Pagination";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import DataTable from "examples/Tables/DataTable";
import Actionables from "components/UpStyled/Actionables";

import { budgetOptions, MANUFACTURER_SERVICES } from "utils/data";
import SuiBadge from "components/SuiBadge";
import SuiTypography from "components/SuiTypography";
import SuiBadgeDot from "components/SuiBadgeDot";
import SuiBox from "components/SuiBox";
import SuiAvatar from "components/SuiAvatar";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import Switch from "@mui/material/Switch";

import { capitalCase } from "capital-case";
import { AccountContext } from "context/account";
import CounterContext from "context/counter";
import Prompt from "components/UpStyled/Prompt";
import toast from "react-hot-toast";
import moment from "moment";
import qs from "query-string";
import { useForm, Controller } from "react-hook-form";

import { filterParser, sortParser } from "utils/helper";
import { projectRequestsSortOptions } from "utils/data";

import ProjectDetail from "pages/ma/project/detail";
import ProjectCard3 from "components/UpStyled/project-card/ProjectCard3";

import MyProjectsContext from "context/my-projects";
import WorkingProjectList from "pages/ma/project/my-projects/components/WorkingProjectList";
import SavedProjectList from "pages/ma/project/my-projects/components/SavedProjectList";

const MAProjectList = ({ tabValue = "working-projects" }) => {
  //const [tabValue, setTabValue] = useState("working-projects");

  const {
    stagesProjects,
    prospects,
    addMyFavoriteProject,
    removeMyFavoriteProject,
    addUnFavoriteProject,
    handleRefresh,
  } = useContext(MyProjectsContext);

  return (
    <Card sx={{ p: 3 }}>
      {/* <ul
        style={{
          display: "inline-block",
          width: "100%",
          borderBottom: "1px solid #DAE0E7",
          listStyleType: "none",
        }}
      >
        <li
          className={`uss-request-tab  ${
            tabValue == "working-projects" ? "uss-request-tab-active" : ""
          } mr-1`}
        >
          <SuiBox
            component="a"
            sx={{ px: 2, my: 1.5, whiteSpace: "nowrap" }}
            onClick={() => {
              handleRefresh();
              setTabValue("working-projects");
            }}
          >
            Working Projects
          </SuiBox>
        </li>
        <li
          className={`uss-request-tab  ${
            tabValue == "saved-projects" ? "uss-request-tab-active" : ""
          } mr-1`}
        >
          <SuiBox
            component="a"
            sx={{ px: 2, my: 1.5, whiteSpace: "nowrap" }}
            onClick={() => {
              handleRefresh();
              setTabValue("saved-projects");
            }}
          >
            Saved Requests
          </SuiBox>
        </li>
      </ul> */}

      {tabValue == "working-projects" ? <WorkingProjectList /> : null}
      {tabValue == "saved-projects" ? <SavedProjectList /> : null}
    </Card>
  );
};

export default MAProjectList;
